// @flow
import { error } from './common';
import * as types from '../types/schools';
import type {
  SCHOOL_TYPE,
  SCHOOL_FETCH_STARTED_TYPE,
  SCHOOL_FETCH_SUCCEED_TYPE,
  SCHOOL_SELECTED_TYPE,
  SCHOOLS_REGISTERED_TYPE,
} from '../types/schools';

export const fetchSchoolStarted = (id: number): SCHOOL_FETCH_STARTED_TYPE => ({
  type: types.SCHOOL_FETCH_STARTED,
  payload: id,
});

export const selectSchool = (id: number): SCHOOL_SELECTED_TYPE => ({
  type: types.SCHOOL_SELECTED,
  payload: id,
});

export const fetchSchoolSucceed = (
  id: number,
  name: string,
  address: string,
  phone: string,
): SCHOOL_FETCH_SUCCEED_TYPE => ({
  type: types.SCHOOL_FETCH_SUCCEED,
  payload: {
    id,
    name,
    address,
    phone,
  },
});

export const fetchSchoolFailed = error(types.SCHOOL_FETCH_FAILED);

export const registerSchools = (entities: { [number]: SCHOOL_TYPE }): SCHOOLS_REGISTERED_TYPE => ({
  type: types.SCHOOLS_REGISTERED,
  payload: {
    entities,
  },
});



// WEBPACK FOOTER //
// ./src/scripts/actions/schools.js